import { useMutation } from '@apollo/client'
import { EditEventPayment, EditEventPaymentVariables } from '../../types'
import { EDIT_EVENT_PAYMENT } from './operations'

export const useEditEventPayment = () =>
  useMutation<EditEventPayment, EditEventPaymentVariables>(EDIT_EVENT_PAYMENT)
